// extracted by mini-css-extract-plugin
export default {"zoomModal":"Q3-z","image":"R3-z","button":"S3-z","isOverlayShown":"T3-z"};